/**
 * Le contrat de `POST /contact`, vu du navigateur.
 *
 * Un seul appel, sans session : le formulaire de la vitrine s’adresse à des
 * gens qui n’ont pas de compte — c’est même tout l’objet de la page.
 *
 * ★ **Le navigateur ne choisit ni le destinataire ni le sujet.** Il envoie une
 *   saisie ; le serveur écrit le message. Un formulaire public dont la requête
 *   porterait l’adresse d’arrivée serait un relais ouvert, et le nom du produit
 *   dans le sujet finirait par diverger entre les deux côtés.
 */

import { api } from '../../lib/api'

/** Ce que le visiteur remplit, plus les deux champs que la page mesure. */
export interface DemandeContact {
  readonly nom: string
  readonly organisation: string
  readonly email: string
  readonly telephone?: string
  readonly message: string
  /**
   * Champ piège. Invisible à l’écran : un être humain le laisse toujours vide,
   * un robot qui remplit tout ce qu’il trouve le renseigne — et son message ne
   * part pas, sans qu’il l’apprenne.
   */
  readonly siteWeb?: string
  /**
   * Durée de saisie, en millisecondes, mesurée en **horloge monotone**
   * (`performance.now()`). Jamais un écart entre deux dates : l’horloge d’un
   * poste peut être fausse, et personne ne doit être écarté pour ça.
   */
  readonly dureeSaisieMs?: number
}

/**
 * L’accusé du serveur.
 *
 * `envoye: false` arrive en **200** : la requête a bien été traitée, c’est le
 * courriel qui n’est pas parti (serveur de messagerie injoignable). Le
 * distinguer d’une panne permet d’afficher la bonne chose au visiteur —
 * l’adresse de l’éditeur en clair — au lieu de « une erreur est survenue ».
 */
export interface AccuseContact {
  readonly envoye: boolean
  /** Phrase écrite par le serveur, affichable telle quelle. */
  readonly message: string
}

export function envoyerDemandeContact(demande: DemandeContact): Promise<AccuseContact> {
  return api.post<AccuseContact>('/contact', demande)
}
